import { Button, Stack, Text, Tooltip } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { isEmpty, unique } from 'remeda';
import { languageName } from 'types/locale';
import type { BlankField } from './use-blank-fields';
import { useSaveTemplate } from './use-save-template';

export const SaveTemplateButton = () => {
  const { t } = useTranslation();
  const { hasUnsavedChanges, isSaving, blankFields, save } = useSaveTemplate();

  const hasBlankFields = !isEmpty(blankFields);

  const button = (
    <Button
      leftSection={<IconDeviceFloppy size={18} stroke={1.5} />}
      onClick={save}
      disabled={!hasUnsavedChanges || hasBlankFields}
      loading={isSaving}
    >
      {t(i18nKeys.SAVE)}
    </Button>
  );

  if (!hasBlankFields) return button;

  const blankBodyLanguages = listLanguages(blankFields, 'body');
  const blankSubjectLanguages = listLanguages(blankFields, 'subject');

  return (
    <Tooltip
      multiline
      w={320}
      label={
        <Stack gap={6}>
          {blankBodyLanguages && (
            <Text size="xs">
              {t(i18nKeys.TEMPLATE.BLANK_BODY_BLOCKS_SAVE, { languages: blankBodyLanguages })}
            </Text>
          )}
          {blankSubjectLanguages && (
            <Text size="xs">
              {t(i18nKeys.TEMPLATE.BLANK_SUBJECT_BLOCKS_SAVE, { languages: blankSubjectLanguages })}
            </Text>
          )}
          <Text size="xs">{t(i18nKeys.TEMPLATE.BLANK_BODY_DISABLE_HINT)}</Text>
        </Stack>
      }
    >
      <span>{button}</span>
    </Tooltip>
  );
};

function listLanguages(blankFields: BlankField[], field: BlankField['field']) {
  return unique(
    blankFields.filter(blank => blank.field === field).map(blank => languageName(blank.locale)),
  ).join(', ');
}
